import './Footer.scss'

export default function Footer() {

	return (
		<footer className='Footer'>
		</footer>
	)
}
